import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faPlus } from '@fortawesome/pro-light-svg-icons'

import { Box, Button, DashboardModule } from '@domain-group/suit-theme'

import type{ UseProviderPayload } from '@hooks/useProvider'
import useProviderDeepLink from '@hooks/useProviderDeepLink'

import DeepLink from './components/DeepLink'

interface DeepLinksProps {
    providerPayload: UseProviderPayload,
}

const DeepLinks = (props: DeepLinksProps) => {
  const { providerPayload } = props

  const {
    provider,
    loading,
    deepLinks,
    hasDeepLinks,
  } = providerPayload

  const { callbacks: { createOrEditProviderDeepLink } } = useProviderDeepLink({}, provider)

  return (
    <DashboardModule
      boxProps={{ id: 'realhub-nav-deep-links' }}
      loading={loading}
      title="Deep Links"
    >
      <Box flexDirection="column">
        {!loading && !hasDeepLinks && (
        <DashboardModule.BlankState>
          <DashboardModule.BlankState.Title>
            No Deep Links present
          </DashboardModule.BlankState.Title>

          <DashboardModule.BlankState.Paragraph>
            Please create a Deep Link below.
          </DashboardModule.BlankState.Paragraph>
        </DashboardModule.BlankState>
        )}

        {!loading && hasDeepLinks && (
          <DashboardModule.ScrollableSection>
            {deepLinks.map(providerDeepLink => (
              <DeepLink
                key={providerDeepLink.id}
                provider={provider}
                // @ts-expect-error TS2322
                providerDeepLink={providerDeepLink}
              />
            ))}
          </DashboardModule.ScrollableSection>
        )}

        <DashboardModule.Footer boxProps={{ borderTop: loading ? 'none' : '1px solid' }}>
          <DashboardModule.FooterRight>
            <Button
              buttonStyle="secondaryEdit"
              icon={<FontAwesomeIcon icon={faPlus} />}
              onClick={() => createOrEditProviderDeepLink()}
              // @ts-expect-error TS2322
              size={['medium', 'small']}
              width={['100%', 'fit-content']}
            >
              Add Deep Link
            </Button>
          </DashboardModule.FooterRight>
        </DashboardModule.Footer>
      </Box>
    </DashboardModule>
  )
}

export default DeepLinks
